/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpStatusCode } from './httpStatusCode';
import { ValidationFieldErrorDto } from './validationFieldErrorDto';


export interface ErrorResponseDto { 
    message?: string | null;
    messageCode?: number | null;
    code?: HttpStatusCode;
    stacktrace?: string | null;
    errors?: Array<ValidationFieldErrorDto> | null;
}

